<template>
  <div>
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Bar, mixins } from "vue-chartjs";

export default {
  name: "BarChart",
  extends: Bar,
  mixins: [mixins.reactiveProp],
  props: ["chartData", "chartOptions"],
  mounted() {
    this.renderChart(this.chartData, this.chartOptions);
  }
};
</script>
